import React from "react";

function IconPlay() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        d="M16.108 9.783a.25.25 0 010 .434L5.124 16.494a.25.25 0 01-.374-.217V3.723a.25.25 0 01.374-.217l10.984 6.277z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default IconPlay;
